import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Year} from '../interface/Year';

@Injectable({
    providedIn: 'root'
})
export class YearService {

    private baseUrl = environment.apiBaseUrl;

    constructor(private http: HttpClient) { }

    getCollection(): Observable<Year[]>{
        return this.http.get<Year[]>(`${this.baseUrl}/get/year`);
    }

    post(data: Year): Observable<any>{
        return this.http.post<Year>(`${this.baseUrl}/create/year`, data);
    }

    put(id: number, data: Year): Observable<any>{
        return this.http.put<Year>(`${this.baseUrl}/edit/year/${id}`, data);
    }

    delete(id: number): Observable<Year>{
        return this.http.delete<Year>(`${this.baseUrl}/delete/year/` + id);
    }

    // others

    setUserCurrentYear(id: number): Observable<Year>{
        return this.http.delete<Year>(`${this.baseUrl}/set/user/current/year/` + id);
    }

    setCurrentYear(id: number): Observable<Year>{
        return this.http.delete<Year>(`${this.baseUrl}/set/current/year/` + id);
    }

    getListStudCourseReg(studentMatricule?: string): Observable<Year[]>{
        return this.http.get<Year[]>(`${this.baseUrl}/year/get/stud-course-reg${studentMatricule ? '/' + studentMatricule : ''}`);
    }

    deleteMultiple(ids: number[]): Observable<Year[]>{
        const options = {body: ids};
        return this.http.delete<Year[]>(`${this.baseUrl}/years/delete`, options);
    }

    getUserCurrentYear(): Observable<Year[]>{
        return this.http.get<Year[]>(`${this.baseUrl}/get/user/current/year`);
    }

    getUserYearLessThanCurrentYear(): Observable<Year[]>{
        return this.http.get<Year[]>(`${this.baseUrl}/get/years/less/current/year`);
    }

}
